export const sellerMarketplaces = {
  AMAZON: 'Amazon',
  AMAZON_VENDOR: 'Amazon Vendor',
  AMAZON_MX: 'Amazon Mexico',
  AMAZON_CA: 'Amazon Canada',
  AMAZON_BR: 'Amazon Brazil',
  AMAZON_ES: 'Amazon Spain',
  AMAZON_FR: 'Amazon France',
  AMAZON_IT: 'Amazon Italy',
  AMAZON_DE: 'Amazon Germany',
  EBAY: 'Ebay',
  EBAY_CA: 'Ebay Canada',
  EBAY_ES: 'Ebay Spain',
  EBAY_DE: 'Ebay Germany',
  WALMART: 'Walmart',
  WALMART_MX: 'Walmart Mexico',
  WALMART_CL: 'Walmart Chile',
  SHOPIFY: 'Shopify',
  SHOPIFY_CL: 'Shopify Chile',
  SHOPIFY_MX: 'Shopify Mexico',
  SHOPIFY_BR: 'Shopify Brazil',
  SHOPIFY_PE: 'Shopify Peru',
  SHOPIFY_CO: 'Shopify Colombia',
  SHOPIFY_US: 'Shopify United States',
  MERCADOLIBRE: 'Mercadolibre',
  MERCADOLIBRE_CHILE: 'Mercadolibre Chile',
  MERCADOLIBRE_MX: 'Mercadolibre Mexico',
  MERCADOLIBRE_CO: 'Mercadolibre Colombia',
  MERCADOLIBRE_BR: 'Mercadolibre Brasil',
  DAFITI: 'Dafiti',
  DAFITI_BR: 'Dafiti Brazil',
  DAFITI_CL: 'Dafiti Chile',
  DAFITI_CO: 'Dafiti Colombia',
  DAFITI_AR: 'Dafiti Argentina',
  COPPEL: 'Coppel',
  LIVERPOOL: 'Liverpool',
  RIPLEY: 'Ripley',
  EDICOMMERCE: 'Edicommerce',
  MAGENTO: 'Magento',
  WOOCOMMERCE: 'Woocommerce',
  FALABELLA: 'Falabella',
  FALABELLA_CO: 'Falabella Colombia',
  FALABELLA_PE: 'Falabella Peru',
  LINIO: 'Linio',
  PRESTASHOP: 'Prestashop',
};

export const marketplaceLabels = {
  [sellerMarketplaces.EDICOMMERCE]: 'Wallmart DSV MX',
};

export const averageSearch = {
  AVERAGE_CONSTANT_SELLER: 3,
};

export const marketplaceCurrency = {
  Amazon: 'USD',
  'Amazon Mexico': 'MXN',
  'Amazon Canada': 'CAD',
  'Amazon Brazil': 'BRL',
  'Amazon Spain': 'EUR',
  'Amazon UK': 'GBP',
  'Amazon France': 'EUR',
  'Amazon Italy': 'EUR',
  'Amazon Germany': 'EUR',
  Ebay: 'USD',
  'Ebay Canada': 'CAD',
  'Ebay Spain': 'EUR',
  'Ebay Germany': 'EUR',
  Walmart: 'USD',
  'Walmart Mexico': 'MXN',
  'Walmart Chile': 'CLP',
  Shopify: 'USD',
  'Shopify Chile': 'CLP',
  'Shopify Mexico': 'MXN',
  'Shopify Brazil': 'BRL',
  'Shopify Peru': 'PEN',
  'Shopify Colombia': 'COP',
  'Shopify United States': 'USD',
  'Mercadolibre Chile': 'CLP',
  'Mercadolibre Mexico': 'MXN',
  'Mercadolibre Colombia': 'COP',
  'Mercadolibre Brasil': 'BRL',
  'Dafiti Chile': 'CLP',
  Coppel: 'MXN',
  Liverpool: 'MXN',
  Ripley: 'CLP',
  Woocommerce: 'USD',
  Falabella: 'CLP',
  'Falabella Colombia': 'COP',
  'Falabella Peru': 'PEN',
  Linio: 'COP',
  Edicommerce: 'USD',
  Prestashop: 'MXN',
};

export const sellerMarketplacesList = [
  { name: sellerMarketplaces.AMAZON },
  { name: sellerMarketplaces.WALMART },
  { name: sellerMarketplaces.EBAY },
  { name: sellerMarketplaces.SHOPIFY },
  { name: sellerMarketplaces.COPPEL },
  { name: sellerMarketplaces.LIVERPOOL },
  { name: sellerMarketplaces.RIPLEY },
  { name: sellerMarketplaces.WOOCOMMERCE },
  { name: sellerMarketplaces.FALABELLA },
  { name: sellerMarketplaces.LINIO },
  { name: sellerMarketplaces.PRESTASHOP },
  { name: sellerMarketplaces.DAFITI },
];

export const ListingStateEnum = {
  PENDING: 'Pendiente',
  PENDING_CLIENT: 'Pendiente Cliente',
  PENDING_LAP: 'Pendiente LAP',
  PENDING_ACKNOWLEDGE: 'Pendiente aceptación',
  COMPLETED: 'Completado',
  SHIPPING: 'En tránsito',
  PUBLISHED: 'Publicado',
  SENT: 'Enviado',
};

export const RestockOrderStepsStateEnum = {
  PENDING: 'Pendiente',
  COMPLETED: 'Completado',
};

export const initialMyAccountData = {
  name: null,
  vat: null,
  industry_id: null,
  street: null,
  zip: null,
  email: null,
  bank_ids: null,
  acc_number: null,
  company_id: null,
  phone: null,
  passport_id: null,
  birthday: null,
  country_id: null,
  x_fantasy_name: null,
  x_employees_number: null,
  x_sales_range: null,
  address: null,
};

export const initialMyBankAccountData = {
  bank: null,
  acc_number: null,
};

export const initialMySellerAccountAmazon = undefined;
export const initialMySellerAccountEbay = {
  // x_aws_id: null,
  // x_aws_id_acc_key: null,
  // x_aws_id_acc_sec: null,
  x_client_id: null,
  x_acc_key: null,
  x_acc_secret: null,
  x_seller_marketplace: sellerMarketplaces.EBAY, // para los mercados amazon, ebay, walmart,
  x_seller_lap: false,
};
export const initialMySellerAccountWalmart = {
  // x_aws_id: null,
  // x_aws_id_acc_key: null,
  // x_aws_id_acc_sec: null,
  x_client_id: null,
  x_acc_key: null,
  x_acc_secret: null,
  x_seller_marketplace: sellerMarketplaces.WALMART, // para los mercados amazon, ebay, walmart,
  x_seller_lap: false,
};

export const initialOrder = {
  ref: null,
  hasVariant: false,
  category: null,
  title: 'A product added by me',
  bulletPoint1: null,
  bulletPoint2: null,
  bulletPoint3: null,
  bulletPoint4: null,
  bulletPoint5: null,
  description: null,
  weight: null,
  refPrice: 123,
  sku: 'FAU570',
  code_ean_upc: null,
  pack: null,
  marketplaces: ['Amazon', 'Walmart'],
  commentsLAP: 'HELLO THERE!',
  competitorsFileURL: null,
  variants: [],
};

export const initialImages = {
  video: null,
  mainPhoto: [],
  productPhoto: [],
  productPhotoInUse: [],
  productPhotoMoreDetails: [],
};

export const initialProductVariant = {
  id: null,
  title: null,
  brand: null,
  bulletPoint1: null,
  bulletPoint2: null,
  bulletPoint3: null,
  bulletPoint4: null,
  bulletPoint5: null,
  description: null,
  components: null,
  weight: null,
  refPrice: null,
  sku: null,
  code_ean_upc: null,
  pack: null,
  variants: [],
};

export const validateMessages = {
  required: `¡Es requerido!`,
  types: {
    email: `¡No tiene un formato válido!`,
    number: `¡No es un número válido!`,
  },
  number: {
    range: `Error del rango numérico`,
  },
};

export const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'YYYY-MM-DD'];
export const maxLength13 = 13;
export const maxLength200 = 200;
export const maxLength500 = 500;
export const maxLength2000 = 2000;

export const URL_SP_AWS =
  'https://lapmarketplace.com/files/Instructivo%20Creaci%C3%B3n%20de%20Cuenta%20Amazon%20-%20LAP.pdf';
export const URL_EBAY =
  'https://lapmarketplace.com/files/Instructivo%20Creaci%C3%B3n%20de%20Cuenta%20Ebay%20-%20LAP.pdf';
export const URL_CALENDLY =
  'https://assets.calendly.com/assets/external/widget.js';
export const USER_CALENDLY = 'onboarding-lap';
export const EVENT_SP_CALENDLY = '30min';
export const EVENT_WELCOME_CALENDLY = 'lap-welcome';

export const marketplaces = [
  { country: 'Canada', marketplaceId: 'A2EUQ1WTGCTBG2', countryCode: 'CA' },
  {
    country: 'United States of America',
    marketplaceId: 'ATVPDKIKX0DER',
    countryCode: 'US',
  },
  { country: 'Mexico', marketplaceId: 'A1AM78C64UM0Y8', countryCode: 'MX' },
  { country: 'Brazil', marketplaceId: 'A2Q3Y263D00KWC', countryCode: 'BR' },
  { country: 'Spain', marketplaceId: 'A1RKKUPIHCS9HS', countryCode: 'ES' },
  {
    country: 'United Kingdom',
    marketplaceId: 'A1F83G8C2ARO7P',
    countryCode: 'GB',
  },
  { country: 'France', marketplaceId: 'A13V1IB3VIYZZH', countryCode: 'FR' },
  {
    country: 'Netherlands',
    marketplaceId: 'A1805IZSGTT6HS',
    countryCode: 'NL',
  },
  { country: 'Germany', marketplaceId: 'A1PA6795UKMFR9', countryCode: 'DE' },
  { country: 'Italy', marketplaceId: 'APJ6JRA9NG5V4', countryCode: 'IT' },
  { country: 'Sweden', marketplaceId: 'A2NODRKZP88ZB9', countryCode: 'SE' },
  { country: 'Turkey', marketplaceId: 'A33AVAJ2PDY3EV', countryCode: 'BR' },
  {
    country: 'United Arab Emirates',
    marketplaceId: 'A2VIGQ35RCS4UG',
    countryCode: 'AE',
  },
  { country: 'India', marketplaceId: 'A21TJRUUN4KGV', countryCode: 'IN' },
  { country: 'Singapore', marketplaceId: 'A19VAU5U5O7RUS', countryCode: 'SG' },
  { country: 'Australia', marketplaceId: 'A39IBJ37TRP1C6', countryCode: 'AU' },
  { country: 'Japan', marketplaceId: 'A21TJRUUN4KGV', countryCode: 'JP' },
];

export const documentTypes = {
  video: 'video',
  text: 'documento',
  image: 'imagen',
  competitors: 'competitors',
  order: 'order',
};

export const validSizesImagesForMarkets = {
  AmazonMinimumSize: 2000,
  AmazonMaximumSize: 10000,
  AmazonMaximumWeight: 7,
  EbayMinimumSize: 500,
  EbayMaximumSize: 10000,
  EbayMaximumWeight: 7, // 7 MB -> 1024 bytes * 1024 kb = 1 MB
  WalmartMinimumSize: 500,
  WalmartMaximumSize: 2,
  WalmartMaximumWeight: 1,
  MercadolibreMinimumSize: 1,
  MercadolibreMaximumSize: 10000,
  MercadolibreMaximumWeight: 10,
};
export const validFormatsImagesForMarkets = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/tiff',
];
export const descriptionImagesForMarkets = {
  Amazon:
    '<ul>' +
    '<span>Requisitos de Formato para fotografías en Amazon</span>' +
    '<li>Las imágenes tienen que representar fielmente el producto que está a la venta y que recibirá el cliente (sin accesorio)</li>' +
    '<li>El producto debe ocupar como mínimo el 85% del área de la imagen.</li>' +
    '<li>Deben tener los formatos JPEG (.jpg o.jpeg), TIFF (.tif), PNG (.png) o GIF (.gif). Se prefiere el formato JPEG.</li>' +
    '<li>No deben estar borrosas o pixeladas, ni tener bordes irregulares. Resolución mínima 150 pp (puntos por pixel)</li>' +
    '<li>Las imágenes principales deben tener un fondo blanco puro,  con un valor RGB de 255, 255, 255.</li>' +
    '<li>Relación de aspecto 1:1 (cuadradas)</li>' +
    '<li>La función de zoom óptima requiere un tamaño mínimo de 2000px x 2000px (pixeles).</li>' +
    '</ul>',
  Ebay:
    '<ul>' +
    '<li>Coloca el artículo contra un fondo liso blanco o de otro color neutro; si vas a hacer una foto de un artículo brillante o reflectante, como una pieza de joyería, es posible que un fondo negro funcione mejor.</li>' +
    '<li>Utiliza un trípode para que la cámara permanezca estable y pueda tomar fotos claras y nítidas. Si no tienes un trípode, coloca la cámara sobre una superficie plana y utiliza el temporizador del obturador para eliminar el exceso de movimiento.</li>' +
    '<li>No uses flash, ya que puede causar la aparición de sombras, reflejos, manchas y zonas grises en la imagen.</li>' +
    '<li>Las fotos deben tener como mínimo 500 píxeles en el lado más largo, pero te recomendamos que procures que tengan entre 800 y 1600 píxeles en el lado más largo. La Herramienta de envío de imágenes de eBay admite imágenes de un tamaño máximo de 7 MB.</li>' +
    '<li>Toma imágenes de las partes superior, inferior y laterales del artículo, con primeros planos detallados. Además, incluye fotos que muestren claramente cualquier defecto, arañazo u otras imperfecciones.</li>' +
    '<li>El formato de las imágenes tiene que ser JPEG (.jpg), TIFF (.tif) o PNG (.png). Se prefiere el formato JPEG.</li>' +
    '<li>No superpongas texto como "envío gratis" ni logotipos del vendedor. La información de ese tipo debe incluirse en el título, el subtítulo o la descripción del artículo.</li>' +
    '<li> Si el artículo que vas a poner en venta es un artículo usado, no puedes utilizar una foto genérica ni de catálogo.</li>' +
    '</ul>',
  Walmart:
    '<ul>' +
    '<li>Recomendaciones de tamaño y formato de imagen: JPEG, JPG, PNG.</li>' +
    '<li>Tamaño máximo del archivo: 1 MB.</li>' +
    '<li>Resolución de imagen recomendada: 2000 x 2000 píxeles a 300 ppp.</li>' +
    '<li>Resolución de imagen recomendada: 1000 x 1000 píxeles a 72 ppp.</li>' +
    '<li>Requisitos mínimos de resolución de imagen: .</li>' +
    '<ul><li>Para capacidad de zoom : 2000 x 2000 píxeles a 300 ppp.</li>' +
    '<li>Sin capacidad de zoom : 500 x 500 píxeles a 72 ppp.</li>' +
    '<li>Nota : No agrande una imagen de baja resolución para cumplir con estos requisitos, ya que disminuirá la calidad de su imagen. **</li></ul>' +
    '<li>Requisitos de URL de imagen: Las URL de imagen deben terminar en un tipo de archivo de imagen (como .jpg, .png, etc.) y deben vincularse a un archivo de imagen público que se carga como una imagen, no como una página HTML.</li>' +
    '<li>El formato de las imágenes tiene que ser JPEG (.jpg), TIFF (.tif) o PNG (.png). Se prefiere el formato JPEG.</li>' +
    '<li>Utiliza un fondo de color blanco puro (valores RGB 255,255,255).</li>' +
    '<li>Para la imagen principal, elija una imagen clara y fácilmente reconocible que resalte las características principales del elemento en una sola toma. En general, nos gustaría que las imágenes del artículo principal se fotografiaran en un ángulo similar (mirando ligeramente a la derecha, lejos de la taxonomía), lo que nos ayuda a mostrar la mejor vista posible del artículo y mantiene nuestras páginas consistentes.</li>' +
    '<li>No superpongas texto como "envío gratis" ni logotipos del vendedor. La información de ese tipo debe incluirse en el título, el subtítulo o la descripción del artículo.</li>' +
    '<li>Vistas prohibidas : no se pueden mostrar marcas de agua, lenguaje publicitario, superposiciones de texto, cupones o bordes en las imágenes.</li>' +
    '<li>Vista de variante sugerida : imagen principal que muestra la variante actual (especialmente si la variante es un color).</li>' +
    '</ul>',
  Shopify:
    '<ul>' +
    '<li>Recomendaciones de tamaño y formato de imagen: JPEG, JPG, PNG.</li>' +
    '<li>Tamaño máximo del archivo: 20 MB.</li>' +
    '<li>Resolución máxima de imagen: 4472 x 4472 píxeles.</li>' +
    '<li>Resolución de imagen recomendada: 2048 x 2048 píxeles.</li>' +
    '<li>Requisitos mínimos de resolución de imagen: .</li>' +
    '<ul><li>Para capacidad de zoom : 800 x 800 píxeles a 300 ppp.</li>' +
    '<li>Sin capacidad de zoom : 500 x 500 píxeles a 72 ppp.</li>' +
    '<li>Nota : No agrande una imagen de baja resolución para cumplir con estos requisitos, ya que disminuirá la calidad de su imagen. **</li></ul>' +
    '<li>Requisitos de URL de imagen: Las URL de imagen deben terminar en un tipo de archivo de imagen (como .jpg, .png, etc.) y deben vincularse a un archivo de imagen público que se carga como una imagen, no como una página HTML.</li>' +
    '<li>El formato de las imágenes tiene que ser JPEG (.jpg), TIFF (.tif) o PNG (.png). Se prefiere el formato JPEG.</li>' +
    '<li>Utiliza un fondo de color blanco puro (valores RGB 255,255,255).</li>' +
    '<li>Para la imagen principal, elija una imagen clara y fácilmente reconocible que resalte las características principales del elemento en una sola toma. En general, nos gustaría que las imágenes del artículo principal se fotografiaran en un ángulo similar (mirando ligeramente a la derecha, lejos de la taxonomía), lo que nos ayuda a mostrar la mejor vista posible del artículo y mantiene nuestras páginas consistentes.</li>' +
    '<li>No superpongas texto como "envío gratis" ni logotipos del vendedor. La información de ese tipo debe incluirse en el título, el subtítulo o la descripción del artículo.</li>' +
    '<li>Vistas prohibidas : no se pueden mostrar marcas de agua, lenguaje publicitario, superposiciones de texto, cupones o bordes en las imágenes.</li>' +
    '<li>Vista de variante sugerida : imagen principal que muestra la variante actual (especialmente si la variante es un color).</li>' +
    '</ul>',
  Mercadolibre:
    '<ul>' +
    '<li>Recomendaciones de tamaño y formato de imagen: JPEG, JPG, PNG.</li>' +
    '<li>Tamaño máximo del archivo: 10 MB.</li>' +
    '<li>Resolución máxima de imagen: 1920 x 1920 píxeles (si la imágen tiene más px, se redimencionará a 1920).</li>' +
    '<li>Resolución mínima de imagen: 40 x 40 píxeles. Si la imagen es más pequeña, será del mismo tamaño (no ampliaremos la imagen)' +
    '<li>Para imágenes de más de 800 píxeles, se activa un widget de zoom para que cuando los compradores se den la vuelta puedan mirar de cerca. Esto es muy recomendable para la ropa.</li>' +
    '</ul>',
};

export const listingSteps = {
  PRICE: 'Price',
  ORDER: 'Order',
  MEASURES: 'Measures',
  IMAGES: 'Images',
  DRAFT: 'Draft',
};
export const listingStates = {
  PENDING: 'Pendiente',
  PENDING_CLIENT: 'Pendiente Cliente',
  PENDING_LAP: 'Pendiente LAP',
  PENDING_ACKNOWLEDGE: 'Pendiente aceptación',
  COMPLETED: 'Completado',
  SHIPPING: 'En tránsito',
  PUBLISHED: 'Publicado',
  SENT: 'Enviado',
};
export const orderSteps = {
  CONTENIDO: 'Contenido',
  CAJAS: 'Cajas',
  ESTADO: 'Estado',
};
export const orderStates = {
  PENDING: 'Pendiente',
  PENDING_CLIENT: 'Pendiente Cliente',
  PENDING_LAP: 'Pendiente LAP',
  PENDING_ACKNOWLEDGE: 'Pendiente aceptación',
  COMPLETED: 'Completado',
};
export const orderGeneralStates = {
  DRAFT: 'Draft',
  WORKING: 'Working',
  READY_TO_SHIP: 'ReadyToShip',
  SHIPPED: 'Shipped',
  IN_TRANSIT: 'InTransit',
  DELIVERED: 'Delivered',
  CHECKED_IN: 'CheckedIn',
  RECEIVING: 'Receiving',
  CLOSED: 'Closed',
  ERROR: 'Error',
  CANCELLED: 'Cancelled',
  DELETED: 'Deleted',
};
export const courierShipmentStatus = {
  CREATED: 'Created',
  PENDING_PAYMENT: 'PendingPayment',
  PENDING_COLLECTION_METHOD: 'PendingCollectionMethod',
  READY_FOR_PICKUP: 'ReadyForPickup',
  SHIPPING: 'InTransit',
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
  ERROR: 'Error',
};
export const noteTypes = {
  NOTE: 'Note',
  CREATE_ORDER: 'Create order',
  STATE_CHANGE: 'State change',
  SENT_PROPOSAL: 'Sent proposal',
  ACCEPTED_PROPOSAL: 'Accepted proposal',
  REJECTED_PROPOSAL: 'Rejected proposal',
  GO_BACK: 'Go back',
};
export const shippingTypes = { AVION: 'Avión', BARCO: 'Barco' };
export const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

/* STEP IMAGES - ONBOARDING * */
export const imageSectionEnum = {
  CATEGORY: 'productCategoryPhoto',
  MAIN: 'mainPhoto',
  PRODUCT: 'productPhoto',
  IN_USE: 'productPhotoInUse',
  MORE_DETAILS: 'productPhotoMoreDetails',
};

/* Order Sales - HOME - */
export const orderSaleStates = {
  PAID: 'Paid',
  PENDING: 'Pending',
  UNSHIPPED: 'Unshipped',
  READY_FOR_PICKUP: 'ReadyForPickup',
  PARTIALLY_SHIPPED: 'PartiallyShipped',
  SHIPPED: 'Shipped',
  CANCELED: 'Canceled',
  UNFULFILLABLE: 'Unfulfillable',
  INVOICE_UNCONFIRMED: 'InvoiceUnconfirmed',
  PENDING_AVAILABILITY: 'PendingAvailability',
  REFUND: 'Refund',
  COMPLETED: 'Completed',
};

/* Order - pedidos - */
export const orderStatesPedidos = {
  PENDING: 'Pending',
  UNSHIPPED: 'Unshipped',
  READY_FOR_PICKUP: 'ReadyForPickup',
  PARTIALLY_SHIPPED: 'PartiallyShipped',
  SHIPPED: 'Shipped',
  CANCELED: 'Canceled',
  UNFULFILLABLE: 'Unfulfillable',
  INVOICE_UNCONFIRMED: 'InvoiceUnconfirmed',
  PENDING_AVAILABILITY: 'PendingAvailability',
  INCIDENT: 'Incident',
};

/* Order - pedidos - */
export const orderFulfillmentStatusPedidos = {
  PENDING: 'Pending',
  CREATED: 'Created',
  CANCELED: 'Canceled',
  COMPLETED: 'Completed',
  SEND_ERROR: 'SendError',
};

export const marketsWithVideos = {
  [sellerMarketplaces.AMAZON]: true,
  [sellerMarketplaces.WALMART]: false,
  [sellerMarketplaces.EBAY]: true,
};

export const dateTypes = {
  PURCHASE_DATE: 'purchaseDate',
  LAST_UPDATE_DATE: 'lastUpdateDate',
};

export const fulfillmentType = {
  FBM: 'FBM',
  FBA: 'FBA',
  FBO: 'FBO',
  MF: 'MF',
};
export const FulfillmentTypeHelp = {
  FBM: 'Fulfillment By Merchant',
  FBA: 'Fulfillment By Amazon',
  FBO: 'Fulfillment By Other',
  MF: 'Mixed Fulfillment',
};
export const FboCouriersEnum = {
  AMAZON: 'Amazon',
  FULFILL99: 'Fulfill99',
  EDARKSTORE: 'eDarkstore',
  MELONN: 'Melonn',
};

export const FulfillmentTypeMap = {
  [FboCouriersEnum.AMAZON]: fulfillmentType.FBA,
  [FboCouriersEnum.FULFILL99]: fulfillmentType.FBO,
  [FboCouriersEnum.EDARKSTORE]: fulfillmentType.FBO,
  [FboCouriersEnum.MELONN]: fulfillmentType.FBO,
  Manual: fulfillmentType.FBM,
  Mixto: fulfillmentType.MF,
  [`${FboCouriersEnum.MELONN} / Manual`]: fulfillmentType.FBO,
};

export const FulfillmentLabelMap = {
  FBM: 'Manual',
  MF: 'Mixto',
};

export const FulfillmentLabel = {
  [fulfillmentType.FBA]: 'Amazon',
  [fulfillmentType.FBM]: 'Manual',
  [fulfillmentType.MF]: 'Mixto',
};

export const onboardingTabs = {
  LAP: 'LAP',
  CLIENT: 'Client',
};

export const tooltipDateOptions = {
  weekday: 'long',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC',
};

export const AllowedFboFbmCompanies = [FboCouriersEnum.MELONN];
export const productStatuses = {
  INACTIVE: ['Inactive', 'UNPUBLISHED', 'closed', 'Incomplete'],
  ACTIVE: ['Active', 'PUBLISHED', 'active', 'Publicado', 'publish'],
};

export const SyncStatusTypesEnum = Object.freeze({
  SYNC_LISTINGS: 'listing-sync-company',
  BULK_LISTINGS: 'imports-submission-sync-company',
  SALE_ORDERS: 'sale-orders-sync-company',
  SALE_ORDERS_ITEMS: 'sale-orders-items-sync-company',
  HISTORICAL_SALE_ORDERS: 'historical-sales-orders',
  STOCK: 'stock-sync-company',
  STOCK_FULFILLMENT_MARKETPLACE: 'stock-sync-fulfillment-marketplace',
  SYNC_SHIPMENTS: 'sync-company-shipments',
});

export const SyncStatusEnum = Object.freeze({
  RUNNING: 'running',
  SUCCESS: 'success',
  ERRORS: 'with_errors',
  CANCELLED: 'cancelled',
});

export const importStatus = Object.freeze({
  PROCESSING: 'Processing',
  POSTING: 'Posting',
  COMPLETED: 'Completed',
  WARNING: 'Warning',
  FAILED: 'Failed',
});
